var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocation = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 10.4167C19.25 12.8629 17.7887 15.4619 16.0314 17.5046C15.164 18.513 14.2537 19.351 13.4767 19.9302C13.0876 20.2203 12.7439 20.4365 12.4658 20.5765C12.327 20.6464 12.2139 20.6926 12.1268 20.7203C12.0354 20.7493 11.9969 20.75 12 20.75V22.25C12.3812 22.25 12.786 22.0947 13.1405 21.9162C13.5186 21.7258 13.9374 21.4577 14.3733 21.1328C15.2463 20.482 16.236 19.5669 17.1686 18.4829C19.0113 16.3409 20.75 13.3982 20.75 10.4167H19.25ZM12 20.75C12.0031 20.75 11.9646 20.7493 11.8732 20.7203C11.7861 20.6926 11.673 20.6464 11.5342 20.5765C11.2561 20.4365 10.9124 20.2203 10.5233 19.9302C9.74629 19.351 8.83605 18.513 7.96856 17.5046C6.21128 15.4619 4.75 12.8629 4.75 10.4167H3.25C3.25 13.3982 4.98872 16.3409 6.83144 18.4829C7.76395 19.5669 8.75371 20.482 9.62674 21.1328C10.0626 21.4577 10.4814 21.7258 10.8595 21.9162C11.214 22.0947 11.6188 22.25 12 22.25V20.75ZM4.75 10.4167C4.75 6.46601 7.98851 3.25 12 3.25V1.75C7.17493 1.75 3.25 5.62281 3.25 10.4167H4.75ZM12 3.25C16.0115 3.25 19.25 6.46601 19.25 10.4167H20.75C20.75 5.62281 16.8251 1.75 12 1.75V3.25Z",
    fill: "current",
    stroke: "none"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 3,
    transform: "matrix(-1 0 0 1 12 10)",
    fill: "none",
    stroke: "current",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocation);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/location.8a5324902ae0cc37368bfd17eed01372.svg";